import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '@core/security/services/auth/auth.service';
import { Router, NavigationStart, NavigationEnd, Event as RouterEvent, ActivatedRoute } from '@angular/router';
import { CoreFacade } from '@core/index';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-sidebar-menu',
	templateUrl: 'sidebar-menu.component.html',
	styleUrls: ['sidebar-menu.component.css'],
})
export class SidebarMenuComponent implements OnInit, OnDestroy {
	public empresaId$: Observable<number>;
	public dutMenu: boolean = false;
	public tablerosMenu: boolean = false;
	public menuPortalEmpresa: boolean = false;

	constructor(
		private authService: AuthService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private coreFacade: CoreFacade
	) {}

	ngOnInit(): void {
		this.empresaId$ = this.coreFacade.getEmpresaId$;
	}

	ngOnDestroy(): void {}

	get usuarioLogueado() {
		return this.authService.isAuthenticated();
	}

	get usuarioLogueado$() {
		return this.authService.isAuthenticatedObs;
	}

	get user() {
		return this.authService.getUser();
	}

	get canSeeCuadroHorario() {
		return this.authService.hasChRoles();
	}

	get empresa$() {
		return this.coreFacade.getEmpresa$;
	}
}
